import { Box, Divider } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import LoadingModal from "../../../components/LoadingModal";
import useArrayObject from "../../../hooks/useArrayObject";
import useInputObject from "../../../hooks/useInputObject";
import { getReportType } from "../../../http/api/MasterAPI";
import { getReportSave } from "../../../http/api/ReportSaveAPI";
import { CompanyTitledPage } from "../../TitledPage";
import HistoryTable from "./HistoryTable";
import PrintBar from "./PrintBar";
import SearchHistory from "./SearchHistory";

const PrintManagePage = () => {
  const [reportTypes, setReportTypes] = useState([]);
  const paging = useInputObject({
    page: 1,
    itemsPerPage: 10,
  });
  const [isLoading, setLoading] = useState(false);
  const printPreview = useInputObject({
    open: false,
    url: "",
  });
  const reports = useArrayObject([]);

  async function GetReportType() {
    let response = await getReportType({});
    let listInfo = response.masterVarInfo;
    listInfo = listInfo.map((o) => ({
      reportTypeId: o.varCd,
      reportTypeName: o.varValue1,
      reportKeyName: o.varValue2,
      displayOrder: o.displayOrder,
    }));
    setReportTypes(listInfo);
  }
  useEffect(() => {
    GetReportType();
  }, []);

  async function SearchReport(searchCondition) {
    let response = await getReportSave(searchCondition);
    let listInfo = response.listReportSaveInfo || [];
    reports.setValue(listInfo);
  }

  return (
    <Fragment>
      <CompanyTitledPage title="帳票印刷画面">
        <Box sx={{ width: "100%", height: "100vh" }}>
          <PrintBar
            reportTypes={reportTypes}
            printPreview={printPreview}
            setLoading={setLoading}
          ></PrintBar>
          <Divider sx={{ fontSize: 25, my: 2 }}>履歴一覧</Divider>
          <SearchHistory
            SearchReport={SearchReport}
            reportTypes={reportTypes}
          ></SearchHistory>
          <HistoryTable
            reports={reports}
            paging={paging}
            reportTypes={reportTypes}
            printPreview={printPreview}
          ></HistoryTable>
        </Box>
        <LoadingModal label="出力中" open={isLoading} />
      </CompanyTitledPage>
    </Fragment>
  );
};
export default PrintManagePage;
